import {
    IDisneyRequestActivationLinkRequest,
    IDisneyRequestActivationLinkResponse,
} from '../../../../lib/entity/interface/iSubscription';
import { container } from '../../../DataDomain';
import { ISubscriptionRepository } from '../../repositories/interfaces/iSubscriptionRepository';
import { DI } from '@intigral/constant/config/DIContainer';

export interface IDisneyRequestActivationLinkUseCase {
    execute(
        params: IDisneyRequestActivationLinkRequest,
        apiToken: { [key: string]: string }
    ): Promise<IDisneyRequestActivationLinkResponse>;
}

export class DisneyRequestActivationLinkUseCase implements IDisneyRequestActivationLinkUseCase {
    private get subscriptionRepository(): ISubscriptionRepository {
        return container.resolve<ISubscriptionRepository>(DI.REPOSITORIES.ISubscriptionRepository);
    }

    async execute(
        params: IDisneyRequestActivationLinkRequest,
        apiToken: { [key: string]: string }
    ): Promise<IDisneyRequestActivationLinkResponse> {
        return await this.subscriptionRepository.disneyRequestActivationLink(params, apiToken);
    }
}
